import React from 'react';

const ProductCard = ({ title, description, link }) => {
  return (
    <div className="product-card">
      <h2>{title}</h2>
      <p>{description}</p>
      <a href={link} target="_blank" rel="noopener noreferrer">Learn More</a>
    </div>
  );
};

export default ProductCard;
